<template>
  <h2 class="aa-faq-app__header" v-html="title" v-if="!id"></h2>
  <!-- FAQ list & filters -->
  <FaqList
      :id="id"
      :customer-group="customerGroup"
      :tag="tag"
      :query="$route.query.query"
      @update-faq-page="updateFaqPage"
  />
</template>

<script>
import FaqList from '@/components/FaqList.vue'

export default {
  name: 'AllFaqs',
  components: {
    FaqList
  },
  props: {
    id: String,
    baseTitle: String,
    customerGroup: String,
    tag: null
  },
  data() {
    return {
      title: this.baseTitle ? this.baseTitle : 'All FAQs',
      faqCount: 0
    };
  },
  methods: {
    // This gets updated by the FaqList child component.
    updateFaqPage(data) {
      this.title = this.baseTitle;

      if (data.tagLabel) {
        this.title += ` <span class="aa-faq-app__header-tag"><i class="fa-solid fa-caret-right"></i> ${data.tagLabel}</span>`;
      }

      this.title += ` <span class="aa-faq-app__header-count bs-badge bg-info">${data.faqCount}</span>`;
    }
  }
}
</script>
